import React from 'react'
import styled from 'styled-components';
import { clearVouchers } from '../redux/pvSlice';
import { useDispatch } from 'react-redux';
//import { useHistory } from 'react-router';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
    width: 100%;
    height: 75vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const ClearBtn = styled.button`
    cursor: pointer;
    background-color: teal;
    color: white;
    padding: 15px 30px;
    border-radius: 5px;
    font-size: 20px;

    &:hover{
        background-color: white;
        color: teal;
    }
`

const ClearText = styled.h1`
    font-size: 20px;
    font-weight: 300;
`

const ClearStore = () => {

    const dispatch = useDispatch();
    //const history = useHistory();
    const navigate = useNavigate();

    const handleClick = async (event) => {
        event.preventDefault();
        console.log('I got clicked');
        // need to await to be entirely sure localForage is cleared
        await dispatch(clearVouchers());
        /* history.push('/'); */
        navigate('/');
    };

    return (
        <Container>
            <ClearText>
                Reset Store By Clicking Button Below
            </ClearText>
            <ClearBtn onClick={(e) => handleClick(e)}>Clear Store</ClearBtn>
        </Container>
    )
}

export default ClearStore
